import { render } from "./DateReport.vue?vue&type=template&id=56711cc4&scoped=true&ts=true"
import script from "./DateReport.vue?vue&type=script&lang=ts"
export * from "./DateReport.vue?vue&type=script&lang=ts"

import "./DateReport.vue?vue&type=style&index=0&id=56711cc4&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56711cc4"]])

export default __exports__